import type { GraphQLError } from 'graphql';

import { locales } from './locales.util';

interface UserFriendlyMessage {
  readonly fr: string;
}

interface CustomBackError extends GraphQLError {
  readonly extensions: Readonly<{
    userFriendlyMessage?: UserFriendlyMessage;
    errCode?: string;
  }>;
}

export interface BackError {
  readonly response: Readonly<{
    errors: readonly CustomBackError[];
  }>;
}

// Each error of a back response, in French when it has a user-friendly message.
export const userFriendlyErrors = (
  error: Readonly<BackError>,
): readonly string[] => [
  ...new Set(
    error.response.errors.map(
      (oneError) =>
        oneError.extensions.userFriendlyMessage?.[locales.fr] ??
        oneError.message,
    ),
  ),
];

const isBackError = (error: unknown): error is BackError =>
  Array.isArray(
    (error as Partial<BackError> | null | undefined)?.response?.errors,
  );

export const describeErrors = (error: unknown): readonly string[] => {
  if (isBackError(error)) {
    return userFriendlyErrors(error);
  }

  return [error instanceof Error ? error.message : String(error)];
};
